import { call, getContext, take } from "redux-saga/effects"
import { omitBy } from "lodash"
import { Types as ProfileTypes } from "model/profileModal"
import { getTickerAndMic } from "helpers/securities"
import { getQueryStringState, stringifyState } from "helpers/queryString"

export default function* urlSaga() {
  while (true) {
    const action = yield take([ProfileTypes.OPEN_SECURITY_PROFILE, ProfileTypes.OPEN_SECURITY_PROFILE2, ProfileTypes.CLOSE_SECURITY_PROFILE, ProfileTypes.OPEN_FACTOR_PROFILE, ProfileTypes.CLOSE_FACTOR_PROFILE])
    let changes

    switch (action.type) {
      case ProfileTypes.OPEN_SECURITY_PROFILE2: {
        const { ticker, mic } = getTickerAndMic(action.assetClass, action.id, action.ticker, action.mic)
        changes = { security: `${mic}.${ticker}`, factor: null }
        break
      }
      case ProfileTypes.OPEN_SECURITY_PROFILE: {
        const { mic, ticker } = action
        changes = { security: `${mic}.${ticker}`, factor: null }
        break
      }
      case ProfileTypes.CLOSE_SECURITY_PROFILE:
        changes = { security: null }
        break
      case ProfileTypes.OPEN_FACTOR_PROFILE: {
        const { id } = action
        changes = { factor: id, security: null }
        break
      }
      case ProfileTypes.CLOSE_FACTOR_PROFILE:
        changes = { factor: null }
        break
      default:
        changes = {}
    }

    // [TODO] should these yield call?
    const currentState = getQueryStringState()
    const newQuery = stringifyState(
      omitBy({ ...currentState, ...changes }, value => !value),
    )

    const { navigate } = yield getContext("router")
    if (newQuery) {
      // changes to browser history are handled by src/sagas/channels/history.js
      // see also: src/sagas/app/history.js
      yield call(navigate, `${document.location.pathname}?${newQuery}`)
    } else {
      yield call(navigate, document.location.pathname)
    }
  }
}
